<template>
    <div class="a-range">
        <div
        v-for="(item) in items"
        v-bind:key="item"
        class="a-range__item"
            :class="{'--active': item <= value}"
            @click="$emit('input', item)"
        >
        {{ item }}
        <!-- <a-icon
                v-if="item <= value "
                icon="AgrofagOn"
            />
            <a-icon
            v-else
            icon="AgrofagOff"
            /> -->
        </div>
        <div  @click="$emit('input', '')" class="a-range__item --reset" :class="{'--active': value === ''}">Wszystkie</div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: ''
        },
        items: {
            type: Number,
            default: null
        }
    }
}
</script>